(() => {
  if (window.sfCardBadgesReady) return;
  window.sfCardBadgesReady = true;
  function setBadge(node, text, sold) {
    if (!node) return;
    node.textContent = text || '';
    node.hidden = !text;
    node.dataset.sfState = sold ? 'sold-out' : 'sale';
    if (node.dataset.sfSaleClass && node.dataset.sfSoldClass) {
      node.classList.remove(node.dataset.sfSaleClass, node.dataset.sfSoldClass);
      node.classList.add(sold ? node.dataset.sfSoldClass : node.dataset.sfSaleClass);
    }
  }
  document.addEventListener('change', event => {
    const select = event.target;
    if (!select.matches?.('[data-sgg-variant],[data-sfsales-variant]')) return;
    const option = select.selectedOptions?.[0];
    if (!option || !Object.hasOwn(option.dataset, 'sfBadgeText')) return;
    setBadge(select.closest('article')?.querySelector('[data-sf-card-badge]'), option.dataset.sfBadgeText, option.dataset.sfBadgeSold === 'true');
  });
  document.addEventListener('variant:update', event => {
    const card = event.target.closest?.('product-card');
    if (!card) return;
    const node = card.querySelector('[data-sf-native-card-badge]'), data = card.querySelector('[data-sf-native-badge-variants]');
    if (!node || !data) return;
    let variant = event.detail?.resource;
    if (!variant?.id) {
      try { variant = JSON.parse(event.detail?.data?.html?.querySelector('variant-picker script[type="application/json"]')?.textContent || 'null'); } catch (_) { variant = null; }
    }
    let choices;
    try { choices = JSON.parse(data.textContent); } catch (_) { return; }
    const match = choices.find(choice => String(choice.id) === String(variant?.id));
    if (!match) { setBadge(node, '', false); return; }
    setBadge(node, match.text, match.sold);
  }, true);
})();
